import fs from 'node:fs/promises';
import {
  getComponentPlaceholderFieldMasks,
  parseLooseAppManifest,
} from '@wix/cli-app-manifest';
import type { WixAstroConfig } from '@wix/cli-astro-definitions';
import { readBuildMetadata } from '../files/build-metadata.js';

export async function processAppManifest({
  projectFolder,
  config,
  serverUrl,
}: {
  projectFolder: string;
  config: WixAstroConfig;
  serverUrl?: string;
}) {
  const {
    metaDataSource,
    appManifestPath,
    staticsUrlPlaceholder,
    serverUrlPlaceholder,
  } = await readBuildMetadata(projectFolder, config);

  if (metaDataSource === 'WIX_CONFIG') {
    return {
      appManifest: { appId: config.appId, components: [] },
      componentPlaceholderFieldMasks: [],
    };
  }

  const placeholders = new Map<string, string>();

  if (serverUrl) {
    if (staticsUrlPlaceholder) {
      placeholders.set(staticsUrlPlaceholder, serverUrl);
    }

    if (serverUrlPlaceholder) {
      placeholders.set(serverUrlPlaceholder, serverUrl);
    }
  }
  const manifest = await fs.readFile(appManifestPath, 'utf-8');

  return {
    appManifest: parseLooseAppManifest(manifest, placeholders),
    componentPlaceholderFieldMasks: getComponentPlaceholderFieldMasks(
      manifest,
      placeholders.keys()
    ),
  };
}
